import {
    GET_NOTIFICATION_SETTINGS_REQUEST,
    GET_NOTIFICATION_SETTINGS_SUCCESS,
    GET_NOTIFICATION_SETTINGS_FAIL,
    CREATE_NOTIFICATION_SETTING_REQUEST,
    CREATE_NOTIFICATION_SETTING_SUCCESS,
    CREATE_NOTIFICATION_SETTING_FAIL,
    UPDATE_NOTIFICATION_SETTING_REQUEST,
    UPDATE_NOTIFICATION_SETTING_SUCCESS,
    UPDATE_NOTIFICATION_SETTING_FAIL,
    DELETE_NOTIFICATION_SETTING_REQUEST,
    DELETE_NOTIFICATION_SETTING_SUCCESS,
    DELETE_NOTIFICATION_SETTING_FAIL,
    SET_NOTIFICATION_SETTINGS_LOADING
} from '../actions/notificationSettingsActions';

const initialState = {
    settings: [],
    loading: false,
    error: null,
    message: ''
};

function notificationSettingsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_NOTIFICATION_SETTINGS_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case GET_NOTIFICATION_SETTINGS_REQUEST:
        case CREATE_NOTIFICATION_SETTING_REQUEST:
        case UPDATE_NOTIFICATION_SETTING_REQUEST:
        case DELETE_NOTIFICATION_SETTING_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_NOTIFICATION_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload,
                loading: false,
                error: null
            };

        case CREATE_NOTIFICATION_SETTING_SUCCESS:
            return {
                ...state,
                settings: [...state.settings, action.payload],
                loading: false,
                message: 'Paramètre de notification créé avec succès'
            };

        case UPDATE_NOTIFICATION_SETTING_SUCCESS:
            return {
                ...state,
                settings: state.settings.map(s => s.id === action.payload.id ? action.payload : s),
                loading: false,
                message: 'Paramètre de notification mis à jour avec succès'
            };

        case DELETE_NOTIFICATION_SETTING_SUCCESS:
            return {
                ...state,
                settings: state.settings.filter(s => s.id !== action.payload.id),
                loading: false,
                message: 'Paramètre de notification supprimé avec succès'
            };

        case GET_NOTIFICATION_SETTINGS_FAIL:
        case CREATE_NOTIFICATION_SETTING_FAIL:
        case UPDATE_NOTIFICATION_SETTING_FAIL:
        case DELETE_NOTIFICATION_SETTING_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default notificationSettingsReducer;
